import { iMetaCustomAudience } from "@sdk/meta-marketing/meta-custom-audiences.models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { metaCustomAudiencesDefaultQueryConfig } from "./meta-custom-audiences-default-query";

export const {
  slice: MetaCustomAudiencesSlice,
  reducers: MetaCustomAudiencesSliceReducer,
  actions: {
    setEntityQueryResults: setMetaCustomAudiencesQueryResults,
    setEntity: setMetaCustomAudience,
    setEntities: setMetaCustomAudiences,
    patchEntity: patchMetaCustomAudience,
    addNewEntity: addNewMetaCustomAudience,
    setEntityFetchingStatus: setMetaCustomAudienceFetchingStatus,
    setEntitiesFetchingStatus: setMetaCustomAudiencesFetchingStatus,
    setEntityFailedStatus: setMetaCustomAudienceFailedStatus,
    setEntityQueryError: setMetaCustomAudiencesQueryError,
    resetQuery: resetMetaCustomAudiencesQuery,
    setQueryList: setMetaCustomAudienceQueryList,
  },
} = CreateEntitySlice<iMetaCustomAudience>({
  sliceName: "metaCustomAudiences",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...metaCustomAudiencesDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
